export const PRODUCT_FAMILY_OPTIONS = {
  PLOOM_S: "s",
  PLOOM_X: "x",
  PLOOM_GEN4: "gen4",
  PLOOM_GEN4AURA: "gen4aura",
  PLOOM_GEN4CUBE: "gen4cube",
} as const;

export type ProductFamilyOptionsType = (typeof PRODUCT_FAMILY_OPTIONS)[keyof typeof PRODUCT_FAMILY_OPTIONS];

export const PRODUCT_FAMILY_VALUES = Object.values(PRODUCT_FAMILY_OPTIONS);
